var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filled / Book"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_COLOR",
    d: "M17.5 13.3854V2.44791C17.5 2.01496 17.1417 1.66666 16.6964 1.66666H5.71429C3.93973 1.66666 2.5 3.0664 2.5 4.79166V15.2083C2.5 16.9336 3.93973 18.3333 5.71429 18.3333H16.6964C17.1417 18.3333 17.5 17.985 17.5 17.5521V17.0312C17.5 16.7871 17.3828 16.5657 17.202 16.4225C17.0614 15.9212 17.0614 14.4922 17.202 13.9909C17.3828 13.8509 17.5 13.6295 17.5 13.3854ZM6.78571 6.02864C6.78571 5.92121 6.87612 5.83332 6.98661 5.83332H14.0848C14.1953 5.83332 14.2857 5.92121 14.2857 6.02864V6.67968C14.2857 6.7871 14.1953 6.87499 14.0848 6.87499H6.98661C6.87612 6.87499 6.78571 6.7871 6.78571 6.67968V6.02864ZM6.78571 8.11197C6.78571 8.00455 6.87612 7.91666 6.98661 7.91666H14.0848C14.1953 7.91666 14.2857 8.00455 14.2857 8.11197V8.76301C14.2857 8.87043 14.1953 8.95832 14.0848 8.95832H6.98661C6.87612 8.95832 6.78571 8.87043 6.78571 8.76301V8.11197ZM15.2701 16.25H5.71429C5.12165 16.25 4.64286 15.7845 4.64286 15.2083C4.64286 14.6354 5.125 14.1667 5.71429 14.1667H15.2701C15.2065 14.7233 15.2065 15.6933 15.2701 16.25Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.62cc58ee25b07c0ea84a41894f0a2e7f.svg";
export { ForwardRef as ReactComponent };